<template>
  <div
    style="align-items: flex-start; background-color: #EEF2F3; box-sizing: border-box; display: flex; flex-direction: column; gap: 0px; height: fit-content; justify-content: flex-start; overflow: hidden; min-height: 100vh; width: 100%"
  >
    <!-- 品牌抬头 -->
    <div
      style="align-items: center; background-color: #FFFFFF; box-sizing: border-box; display: flex; flex-direction: column; flex-shrink: 0; gap: 16px; height: 64px; justify-content: flex-start; padding: 10px 24px 0px 24px; width: 100%"
    >
      <div
        style="align-items: center; box-sizing: border-box; display: flex; flex-direction: row; flex-shrink: 0; gap: 12px; height: 28px; justify-content: center; width: 100%"
      >
        <div
          style='box-sizing: border-box; color: #123752; font-family: "Noto Sans SC", system-ui, sans-serif; font-size: 18px; font-style: normal; font-weight: 600; letter-spacing: 0px; line-height: 22px; text-align: left; white-space: nowrap'
        >
          墨计星盘
        </div>
        <div
          style="align-items: flex-start; background-color: #C8D6DE; box-sizing: border-box; display: flex; flex-direction: row; flex-shrink: 0; gap: 0px; height: 16px; justify-content: flex-start; width: 1px"
        ></div>
        <div
          style='box-sizing: border-box; color: #123752; font-family: "Noto Sans SC", system-ui, sans-serif; font-size: 18px; font-style: normal; font-weight: 600; letter-spacing: 0px; line-height: 22px; text-align: left; white-space: nowrap'
        >
          AI背调
        </div>
      </div>
      <div
        style="align-items: flex-start; background-color: #DFE7EC; box-sizing: border-box; display: flex; flex-direction: row; flex-shrink: 0; gap: 0px; height: 1px; justify-content: flex-start; width: 100%"
      ></div>
    </div>
    <div
      style="align-items: flex-start; background-color: #EEF2F3; box-sizing: border-box; display: flex; flex-direction: column; flex-shrink: 0; gap: 0px; height: fit-content; justify-content: flex-start; width: 100%"
    >
      <!-- 报告概览区 -->
      <div
        style="align-items: flex-start; background-color: #EEF2F3; box-sizing: border-box; display: flex; flex-direction: column; flex-shrink: 0; gap: 12px; height: fit-content; justify-content: flex-start; padding: 12px; width: 100%"
      >
        <!-- 人员信息卡 -->
        <div
          style="align-items: flex-start; background-image: linear-gradient(-104.99deg, #0B263F 14.645%, #17466F 85.355%); background-repeat: no-repeat; background-size: 100% 100%; border-radius: 12px; box-sizing: border-box; display: flex; flex-direction: column; flex-shrink: 0; gap: 6px; height: fit-content; justify-content: flex-start; padding: 16px; width: 100%"
        >
          <div
            style="align-items: center; box-sizing: border-box; display: flex; flex-direction: row; flex-shrink: 0; gap: 10px; height: fit-content; justify-content: flex-start; width: 100%"
          >
            <div
              style="align-items: center; background-color: #FFFFFF12; border-radius: 8px; box-sizing: border-box; display: flex; flex-direction: row; flex-shrink: 0; gap: 0px; height: 40px; justify-content: center; outline-offset: -0.5px; outline: 1px solid #FFFFFF20; width: 40px"
            >
              <svg
                data-icon-name="user-round"
                data-icon-set="lucide"
                viewBox="0 0 13.99993896484375 14"
                preserveAspectRatio="xMidYMid meet"
                xmlns="http://www.w3.org/2000/svg"
                style="box-sizing: border-box; flex-shrink: 0; height: 26px; width: 26px"
              >
                <path
                  d="M6.53857 1.20313q-1.17578 0.15381-2.0166 0.99462-0.51953 0.51953-0.78613 1.19287-0.26318 0.66992-0.23584 1.41163 0.02734 0.7417 0.35547 1.40136 0.33154 0.65625 0.91943 1.15869l0.09571 0.08545-0.19483 0.09912q-0.89551 0.44775-1.58252 1.20313-0.68359 0.75537-1.02197 1.69531-0.25293 0.68359-0.30762 1.39795-0.04102 0.49219 0.04102 0.65967 0.12646 0.2666 0.42041 0.31445 0.29395 0.04785 0.50586-0.14697 0.10938-0.11279 0.14355-0.2085 0.0376-0.09912 0.05127-0.35205 0.01367-0.3623 0.06152-0.6289 0.05127-0.2666 0.16407-0.57422 0.37598-1.09375 1.29199-1.83545 0.91943-0.7417 2.08154-0.86817 0.71436-0.08203 1.41846 0.08545 0.70752 0.16748 1.30908 0.56055 0.19824 0.12646 0.30078 0.21875 0.10596 0.08887 0.28711 0.25635 0.32471 0.32129 0.56738 0.68701 0.24609 0.36231 0.41358 0.80322 0.16748 0.44092 0.22558 0.875 0.01367 0.14014 0.02735 0.42041 0.01367 0.25293 0.04785 0.35205 0.0376 0.0957 0.14697 0.2085 0.21191 0.19482 0.50586 0.14697 0.29395-0.04785 0.42041-0.31445 0.02734-0.08545 0.03418-0.1333 0.00684-0.05127 0.00684-0.28711 0-0.78613-0.28711-1.58936-0.28711-0.80664-0.80664-1.46289-0.36231-0.4751-0.86817-0.88183-0.50244-0.40674-1.00488-0.62891l-0.14014-0.07178 0.09571-0.08545q0.71436-0.60156 1.03564-1.42529 0.36572-0.95361 0.1709-1.97558-0.19824-0.98096-0.90576-1.71582-0.70752-0.73486-1.68506-0.97071-0.29395-0.07178-0.65283-0.09228-0.35547-0.02051-0.64942 0.0205z m0.79639 1.1621q0.646 0.08545 1.15527 0.51954 0.5127 0.43408 0.7212 1.06298 0.12646 0.36572 0.11962 0.7793-0.00684 0.41016-0.14697 0.74854-0.22559 0.60156-0.72119 1.00146-0.49561 0.39648-1.12793 0.49561-0.48877 0.08203-0.99463-0.07178-0.50244-0.15381-0.86474-0.4751-0.58789-0.51611-0.75879-1.2749-0.02734-0.15381-0.03418-0.41699-0.00684-0.2666 0.0205-0.42041 0.11279-0.72803 0.60157-1.24756 0.32471-0.33496 0.7417-0.53321 0.59131-0.26318 1.28857-0.16748z"
                  fill="#CBE4FA"
                ></path>
              </svg>
            </div>
            <div
              style='box-sizing: border-box; color: #FFFFFF; flex: 1 1 0; font-family: "Noto Sans SC", system-ui, sans-serif; font-size: 22px; font-style: normal; font-weight: 700; letter-spacing: 0px; line-height: normal; text-align: left; width: 100%'
            >
              {{ person.name }}
            </div>
          </div>
          <div
            style='box-sizing: border-box; color: #C5D7E6; font-family: "Noto Sans SC", system-ui, sans-serif; font-size: 14px; font-style: normal; font-weight: 400; letter-spacing: 0px; line-height: normal; text-align: left; width: 100%'
          >
            身份证号 {{ person.idCard }}
          </div>
        </div>
        <!-- 概览分区标题 -->
        <div
          style='box-sizing: border-box; color: #152D43; font-family: "Noto Sans SC", system-ui, sans-serif; font-size: 20px; font-style: normal; font-weight: 600; letter-spacing: 0px; line-height: 28px; text-align: left; white-space: nowrap'
        >
          报告概览
        </div>
        <!-- AI解读与建议 -->
        <div
          style="align-items: flex-start; background-color: #F5FAFA; border-radius: 10px; box-sizing: border-box; display: flex; flex-direction: column; flex-shrink: 0; gap: 16px; height: fit-content; justify-content: flex-start; outline-offset: -0.5px; outline: 1px solid #B8D8DB; padding: 14px; width: 100%"
        >
          <div
            style="align-items: center; box-sizing: border-box; display: flex; flex-direction: row; flex-shrink: 0; gap: 8px; height: fit-content; justify-content: flex-start; width: 100%"
          >
            <svg
              data-icon-name="sparkles"
              data-icon-set="lucide"
              viewBox="0 0 13.99993896484375 14"
              preserveAspectRatio="xMidYMid meet"
              xmlns="http://www.w3.org/2000/svg"
              style="box-sizing: border-box; flex-shrink: 0; height: 20px; width: 20px"
            >
              <path
                d="M6.84619 0.58789q-0.28027 0.04102-0.54687 0.22559-0.29395 0.2085-0.40674 0.57422-0.02734 0.08203-0.3418 1.75683-0.31445 1.67139-0.35889 1.76367-0.04102 0.08887-0.10937 0.16065-0.07178 0.08203-0.15381 0.11279-0.11279 0.04102-0.4751 0.12305l-1.28857 0.23926q-1.68164 0.32129-1.77734 0.34863-0.23926 0.07178-0.44434 0.27002-0.20166 0.19482-0.29395 0.44092-0.08887 0.24268-0.06152 0.50244 0.02734 0.25635 0.16748 0.4956 0.09912 0.16748 0.27344 0.30762 0.17432 0.14014 0.35889 0.19824 0.0957 0.02734 1.76367 0.34863l1.28515 0.25293q0.37939 0.06836 0.50586 0.10938 0.08203 0.04443 0.15381 0.11279 0.05469 0.08545 0.09912 0.16748 0.04102 0.12646 0.10938 0.50586l0.23926 1.24414q0.32129 1.68164 0.34863 1.76367 0.15381 0.46484 0.58789 0.67335 0.2666 0.14014 0.51953 0.14013 0.25293 0 0.51953-0.14013 0.43408-0.2085 0.58789-0.67335 0.02734-0.08203 0.3418-1.74658 0.31445-1.66797 0.3418-1.72265 0.02734-0.11279 0.12646-0.2085 0.09912-0.09912 0.21191-0.14355 0.06836-0.02734 1.73291-0.3418 1.66797-0.31445 1.75-0.3418 0.46484-0.15381 0.67335-0.58789 0.2666-0.51953 0-1.03906-0.09912-0.2085-0.28028-0.36231-0.18115-0.15381-0.39307-0.22558-0.0957-0.02734-1.77734-0.34863l-1.23047-0.23926q-0.37939-0.06836-0.50586-0.10938-0.0957-0.03076-0.15381-0.08545-0.10938-0.11279-0.1538-0.23925-0.02734-0.06836-0.3418-1.73291-0.31445-1.66797-0.3418-1.75-0.14014-0.46484-0.60498-0.68702-0.14014-0.07178-0.31445-0.09912-0.17432-0.02734-0.3418-0.01367z m4.73047 0.01367q-0.12305 0.01367-0.24268 0.09912-0.11963 0.08203-0.1914 0.19483-0.04102 0.08545-0.05469 0.20508-0.01367 0.11621-0.01367 0.35546l0 0.29395-0.36572 0q-0.26318 0.01367-0.32813 0.02051-0.06152 0.00684-0.1333 0.03418-0.2666 0.12646-0.31445 0.42041-0.04785 0.29395 0.14697 0.50586 0.08545 0.08203 0.18115 0.14013 0.08545 0.02734 0.14697 0.03418 0.06494 0.00684 0.31788 0.02051l0.34863 0 0 0.34863q0.01367 0.25293 0.02051 0.31788 0.00683 0.06152 0.03418 0.14697 0.05811 0.0957 0.14013 0.18115 0.21191 0.19482 0.50586 0.14697 0.29395-0.04785 0.42041-0.31445 0.02734-0.08545 0.03418-0.14014 0.00684-0.05811 0.02051-0.32129l0-0.36572 0.29395 0q0.32129 0 0.45458-0.03418 0.1333-0.03418 0.25293-0.15381 0.11963-0.11963 0.15381-0.31445 0.03418-0.19824-0.04785-0.35205-0.04443-0.08203-0.12305-0.15039-0.0752-0.07178-0.1538-0.10596-0.07519-0.0376-0.14014-0.04443-0.06152-0.00684-0.32813-0.02051l-0.3623 0 0-0.34863q0-0.23926-0.00684-0.30762-0.00684-0.07178-0.03418-0.12646-0.08545-0.21191-0.25293-0.30762-0.16748-0.09912-0.37939-0.05811z m-4.26904 2.7583q0.23926 1.26123 0.29394 1.55518 0.05811 0.29395 0.1128 0.42041 0.12646 0.30762 0.38281 0.56738 0.25977 0.25635 0.56738 0.38281 0.12646 0.05469 0.41358 0.1128 0.28711 0.05469 1.54833 0.29394 1.56885 0.29395 1.57569 0.30762 0.00684 0.01367-1.60303 0.31445-1.60986 0.30078-1.72266 0.32813-0.39307 0.09912-0.72119 0.40674-0.32813 0.30762-0.46826 0.70068-0.04443 0.09912-0.09912 0.43408l-0.32129 1.63721q-0.25293 1.37402-0.2666 1.37402-0.01367 0-0.30762-1.55517-0.23926-1.2749-0.29736-1.56202-0.05469-0.28711-0.10938-0.41357-0.09912-0.23584-0.30078-0.46484-0.20166-0.23242-0.41357-0.35889-0.14014-0.09912-0.2666-0.14014-0.16748-0.04102-0.57422-0.12646l-1.28516-0.25293q-1.6543-0.30762-1.64062-0.32129 0.01367-0.01367 1.60986-0.30762l1.51416-0.29394q0.25293-0.05811 0.38965-0.1128 0.29395-0.11279 0.56738-0.37597 0.27344-0.2666 0.3999-0.57422 0.05469-0.12646 0.10938-0.41358 0.05811-0.28711 0.29736-1.56201 0.29395-1.55518 0.30762-1.55517 0.01367 0 0.30762 1.55517z m-5.33203 6.59326q-0.31104 0.07178-0.57764 0.23926-0.26318 0.16748-0.46143 0.42041-0.34863 0.4751-0.34863 1.05615 0 0.58105 0.3418 1.04249 0.34521 0.46143 0.91943 0.6289 0.64258 0.18457 1.25781-0.10937 0.32471-0.15381 0.56055-0.44092 0.23926-0.28711 0.35205-0.65283 0.02734-0.11279 0.03418-0.18116 0.00684-0.06836 0.02051-0.28027 0-0.25293-0.02051-0.3623-0.02051-0.11279-0.10596-0.32471-0.15381-0.36231-0.46826-0.63574-0.31445-0.27344-0.70752-0.38623-0.15381-0.02734-0.3999-0.03418-0.24268-0.00684-0.39648 0.0205z m0.60156 1.18946q0.24951 0.11279 0.31787 0.38623 0.07178 0.27344-0.0957 0.48193-0.12646 0.15381-0.29395 0.21192-0.16748 0.05469-0.33496 0-0.25293-0.07178-0.37939-0.33497-0.04102-0.09912-0.03418-0.23242 0.00684-0.1333 0.04785-0.23242 0.09912-0.22217 0.32129-0.29736 0.22559-0.07861 0.45117 0.01709z"
                fill="#315873"
              ></path>
            </svg>
            <div
              style='box-sizing: border-box; color: #123752; flex: 1 1 0; font-family: "Noto Sans SC", system-ui, sans-serif; font-size: 18px; font-style: normal; font-weight: 600; letter-spacing: 0px; line-height: 25px; text-align: left'
            >
              AI解读与建议
            </div>
          </div>
          <!-- 本次核验结果条：配色按风险等级动态映射 -->
          <div
            style="align-items: center; background-color: #F0F6FC; border-radius: 7px; box-sizing: border-box; display: flex; flex-direction: row; flex-shrink: 0; gap: 10px; height: fit-content; justify-content: flex-start; outline-offset: -0.5px; outline: 1px solid #CCDEEF; padding: 12px; width: 100%"
            :style="{ backgroundColor: resultTheme.backgroundColor, outlineColor: resultTheme.outlineColor }"
          >
            <svg
              data-icon-name="shield"
              data-icon-set="lucide"
              viewBox="0 0 13.99993896484375 14"
              preserveAspectRatio="xMidYMid meet"
              xmlns="http://www.w3.org/2000/svg"
              style="box-sizing: border-box; flex-shrink: 0; height: 24px; width: 24px"
            >
              <path
                v-if="resultTheme.icon === 'shield-check'"
                d="M6.84619 0.60156q-0.34863 0.02734-0.68701 0.30762-0.51611 0.42041-1.00147 0.70068-0.48193 0.28027-1.01513 0.4751-0.30762 0.11279-0.58789 0.1709-0.28027 0.05469-0.66992 0.08203-0.23926 0.01367-0.36573 0.07178-0.19482 0.06836-0.37939 0.22217-0.18115 0.15381-0.26319 0.34863l-0.01367 0.03076q-0.07178 0.12646-0.08545 0.22217-0.01367 0.15381-0.02734 0.60156l0 1.78076q0 2.25244 0.01367 2.46094 0.14014 1.6543 1.10742 2.88477 0.14014 0.16748 0.43409 0.46142 0.29395 0.29394 0.48877 0.44775 0.92285 0.7417 2.2832 1.27491 0.46143 0.18115 0.65625 0.23926 0.23926 0.05469 0.43408 0.01367 0.16748-0.02734 0.5332-0.15381 1.35693-0.51953 2.27979-1.20313 0.37939-0.2666 0.71435-0.60498 1.37402-1.3706 1.54151-3.37353 0.01367-0.23584 0.01367-2.46094 0-2.22852-0.02734-2.35498-0.07178-0.32129-0.31787-0.56396-0.24268-0.24609-0.5503-0.31788-0.09912-0.02734-0.37939-0.04101-0.48877-0.02734-0.96387-0.18115-0.81348-0.2666-1.55518-0.77246-0.2666-0.18115-0.64257-0.48877-0.42041-0.33496-0.96729-0.28028z m0.43408 1.34326q0.64258 0.51953 1.32959 0.86817 1.2168 0.61865 2.25244 0.68701l0.21192 0-0.01367 4.31348q0 0.33496-0.02735 0.50244-0.22559 1.34326-1.1416 2.27637-0.91602 0.92969-2.66601 1.57226l-0.21192 0.08545-0.18115-0.05469q-2.32422-0.85449-3.2334-2.22851-0.47852-0.71436-0.63232-1.63721-0.02734-0.18115-0.02735-0.50244l-0.01367-4.32715 0.19483 0q0.86816-0.05469 1.84912-0.48193 0.98096-0.42725 1.83545-1.12793 0.16748-0.14014 0.19482-0.14014 0.02734 0 0.28027 0.19482z m1.32959 3.31885q-0.06836 0.02734-0.12646 0.05127-0.05469 0.02051-1.06299 1.02539l-0.99463 0.99463-0.40674-0.40332q-0.2666-0.2666-0.3623-0.33838-0.12646-0.11279-0.19824-0.14013-0.06836-0.02734-0.19483-0.02735-0.12646 0-0.16748 0.01367-0.04102 0.01367-0.09912 0.04102-0.18115 0.09912-0.28027 0.2666-0.04102 0.08545-0.04102 0.25293l0 0.01367q0 0.14014 0.03418 0.21192 0.0376 0.06836 0.17774 0.22216 0.0957 0.11279 0.48876 0.50586l0.04102 0.04102q0.42041 0.42041 0.55371 0.54687 0.1333 0.12305 0.20166 0.15381 0.14014 0.06836 0.29395 0.05469 0.15381-0.01367 0.28027-0.09912 0.07178-0.05469 1.28857-1.27149 0.86816-0.86816 1.04932-1.06298 0.18457-0.19824 0.21192-0.27002 0.0957-0.27686-0.05811-0.52295-0.15381-0.24609-0.44775-0.25977-0.12646-0.01367-0.18116 0z"
                :fill="resultTheme.iconFill"
              ></path>
              <path
                v-else
                d="M6.84619 0.60156q-0.34863 0.02734-0.68701 0.30762-0.51611 0.42041-1.00147 0.70068-0.48193 0.28027-1.01513 0.4751-0.30762 0.11279-0.58789 0.1709-0.28027 0.05469-0.66992 0.08203-0.23926 0.01367-0.36573 0.07178-0.19482 0.06836-0.37939 0.22217-0.18115 0.15381-0.26319 0.34863l-0.01367 0.03076q-0.07178 0.12646-0.08545 0.22217-0.01367 0.15381-0.02734 0.60156l0 1.78076q0 2.25244 0.01367 2.46094 0.14014 1.6543 1.10742 2.88477 0.14014 0.16748 0.43409 0.46142 0.29395 0.29394 0.48877 0.44775 0.92285 0.7417 2.2832 1.27491 0.46143 0.18115 0.65625 0.23926 0.23926 0.05469 0.43408 0.01367 0.16748-0.02734 0.5332-0.15381 1.35693-0.51953 2.27979-1.20313 0.37939-0.2666 0.71435-0.60498 1.37402-1.3706 1.54151-3.37353 0.01367-0.23584 0.01367-2.46094 0-2.22852-0.02734-2.35498-0.07178-0.32129-0.31787-0.56396-0.24268-0.24609-0.5503-0.31788-0.09912-0.02734-0.37939-0.04101-0.48877-0.02734-0.96387-0.18115-0.81348-0.2666-1.55518-0.77246-0.2666-0.18115-0.64257-0.48877-0.42041-0.33496-0.96729-0.28028z m0.43408 1.34326q0.64258 0.51953 1.32959 0.86817 1.2168 0.61865 2.25244 0.68701l0.21192 0-0.01367 4.31348q0 0.33496-0.02735 0.50244-0.22559 1.34326-1.1416 2.27637-0.91602 0.92969-2.66601 1.57226l-0.21192 0.08545-0.18115-0.05469q-2.32422-0.85449-3.2334-2.22851-0.47852-0.71436-0.63232-1.63721-0.02734-0.18115-0.02735-0.50244l-0.01367-4.32715 0.19483 0q0.86816-0.05469 1.84912-0.48193 0.98096-0.42725 1.83545-1.12793 0.16748-0.14014 0.19482-0.14014 0.02734 0 0.28027 0.19482z m-0.37939 2.15674q-0.0957 0.01367-0.17432 0.05127-0.0752 0.03418-0.15381 0.12647-0.0752 0.08887-0.11279 0.16748-0.03418 0.0752-0.03418 0.25634l0 2.46436 0.04102 0.08545q0.04443 0.06836 0.12646 0.15381 0.08545 0.08203 0.16065 0.12646 0.07861 0.04102 0.24609 0.04102 0.16748 0 0.24268-0.04102 0.07861-0.04443 0.16064-0.12646 0.08545-0.08545 0.12988-0.15381l0.04102-0.08545 0-2.33789q0-0.2666-0.02051-0.3418-0.02051-0.07861-0.07861-0.16064l-0.01367-0.01367q-0.09912-0.12646-0.2461-0.18116-0.14697-0.05811-0.31445-0.03076z m-0.05469 4.67578q-0.2085 0.05811-0.32129 0.22559-0.11279 0.16748-0.09912 0.37256 0.01367 0.20166 0.15381 0.35547 0.08545 0.08203 0.15381 0.12646 0.21191 0.0957 0.42041 0.03418 0.2085-0.06494 0.33496-0.24609 0.12646-0.18115 0.08545-0.40674-0.01367-0.10938-0.05127-0.17773-0.03418-0.07178-0.11963-0.14014-0.08203-0.07178-0.16064-0.11279-0.0752-0.04443-0.19483-0.05127-0.11621-0.00684-0.20166 0.0205z"
                :fill="resultTheme.iconFill"
              ></path>
            </svg>
            <div
              style='box-sizing: border-box; flex: 1 1 0; font-family: "Noto Sans SC", system-ui, sans-serif; font-size: 24px; font-style: normal; font-weight: 600; letter-spacing: 0px; line-height: 34px; text-align: left'
              :style="{ color: resultTheme.color }"
            >
              {{ risk.levelDescription }}
            </div>
          </div>
          <div
            style='box-sizing: border-box; font-family: "Noto Sans SC", system-ui, sans-serif; font-size: 16px; font-style: normal; font-weight: 400; letter-spacing: 0px; line-height: 26px; text-align: left; width: 100%'
            :style="{ color: resultTheme.textColor }"
          >
            {{ aiConclusion }}
          </div>
          <div
            style="background-color: #E8EDF2; box-sizing: border-box; flex-shrink: 0; height: 1px; width: 100%"
          ></div>
          <div
            style='box-sizing: border-box; font-family: "Noto Sans SC", system-ui, sans-serif; font-size: 16px; font-style: normal; font-weight: 600; letter-spacing: 0px; line-height: 26px; text-align: left; width: 100%'
            :style="{ color: resultTheme.titleColor }"
          >
            用工建议
          </div>
          <div
            style='box-sizing: border-box; font-family: "Noto Sans SC", system-ui, sans-serif; font-size: 16px; font-style: normal; font-weight: 400; letter-spacing: 0px; line-height: 26px; text-align: left; width: 100%'
            :style="{ color: resultTheme.textColor }"
          >
            {{ aiSuggestion }}
          </div>
          <!-- 重点关注 -->
          <div
            v-if="keyRisks.length > 0"
            style="align-items: flex-start; box-sizing: border-box; display: flex; flex-direction: column; flex-shrink: 0; gap: 12px; height: fit-content; justify-content: flex-start; width: 100%"
          >
            <div
              style="align-items: center; box-sizing: border-box; display: flex; flex-direction: row; flex-shrink: 0; gap: 12px; height: fit-content; justify-content: space-between; width: 100%"
            >
              <div
                style='box-sizing: border-box; color: #152D43; font-family: "Noto Sans SC", system-ui, sans-serif; font-size: 18px; font-style: normal; font-weight: 600; letter-spacing: 0px; line-height: 25px; text-align: left; white-space: nowrap'
              >
                重点关注
              </div>
              <div
                style='box-sizing: border-box; color: #53687A; font-family: "Noto Sans SC", system-ui, sans-serif; font-size: 14px; font-style: normal; font-weight: 400; letter-spacing: 0px; line-height: 22px; text-align: left; white-space: nowrap'
              >
                {{ keyRisks.length }} 类需关注
              </div>
            </div>
            <div
              v-for="(kr, idx) in keyRisks"
              :key="idx"
              style="align-items: center; border-radius: 6px; box-sizing: border-box; display: flex; flex-direction: row; flex-shrink: 0; gap: 10px; height: fit-content; justify-content: space-between; padding: 12px; width: 100%"
              :style="{ backgroundColor: keyRiskTheme(kr.level).backgroundColor }"
            >
              <div
                style="align-items: flex-start; box-sizing: border-box; display: flex; flex-direction: column; flex: 1 1 0; gap: 3px; height: fit-content; justify-content: flex-start"
              >
                <div
                  style='box-sizing: border-box; font-family: "Noto Sans SC", system-ui, sans-serif; font-size: 15px; font-style: normal; font-weight: 600; letter-spacing: 0px; line-height: 24px; text-align: left; width: 100%'
                  :style="{ color: keyRiskTheme(kr.level).color }"
                >
                  {{ kr.item }}
                </div>
                <div
                  style='box-sizing: border-box; color: #53687A; font-family: "Noto Sans SC", system-ui, sans-serif; font-size: 14px; font-style: normal; font-weight: 400; letter-spacing: 0px; line-height: 22px; text-align: left; width: 100%'
                >
                  {{ kr.description }}
                </div>
              </div>
              <div
                style="align-items: center; box-sizing: border-box; display: flex; flex-direction: row; flex-shrink: 0; gap: 0px; height: 44px; justify-content: center; width: 80px"
                @click="scrollToRecord(kr)"
              >
                <div
                  style='box-sizing: border-box; color: #215C9D; font-family: "Noto Sans SC", system-ui, sans-serif; font-size: 14px; font-style: normal; font-weight: 600; letter-spacing: 0px; line-height: 21px; text-align: left; white-space: nowrap'
                >
                  查看记录
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- 核验详情区 -->
      <div
        style="align-items: flex-start; background-color: #EEF2F3; box-sizing: border-box; display: flex; flex-direction: column; flex-shrink: 0; gap: 12px; height: fit-content; justify-content: flex-start; padding: 0px 12px 12px 12px; width: 100%"
      >
        <div
          style='box-sizing: border-box; color: #152D43; font-family: "Noto Sans SC", system-ui, sans-serif; font-size: 20px; font-style: normal; font-weight: 600; letter-spacing: 0px; line-height: 28px; text-align: left; width: 100%'
        >
          核验详情
        </div>
        <!-- 身份核实 -->
        <div
          ref="anchorIdentity"
          style="align-items: flex-start; background-color: #FBFAF6; border-radius: 7px; box-sizing: border-box; display: flex; flex-direction: column; flex-shrink: 0; gap: 10px; height: fit-content; justify-content: flex-start; outline-offset: -0.5px; outline: 1px solid #D6E0E6; padding: 14px; width: 100%"
        >
          <div
            style="align-items: center; box-sizing: border-box; display: flex; flex-direction: row; flex-shrink: 0; gap: 12px; height: fit-content; justify-content: space-between; width: 100%"
          >
            <div
              style='box-sizing: border-box; color: #152D43; font-family: "Noto Sans SC", system-ui, sans-serif; font-size: 18px; font-style: normal; font-weight: 600; letter-spacing: 0px; line-height: 25px; text-align: left; white-space: nowrap'
            >
              身份核实
            </div>
            <div
              style="align-items: flex-start; background-color: #EAF2FB; border-radius: 6px; box-sizing: border-box; display: flex; flex-direction: row; flex-shrink: 0; gap: 0px; height: fit-content; justify-content: flex-start; padding: 4px 8px; width: fit-content"
            >
              <div
                style='box-sizing: border-box; color: #215C9D; font-family: "Noto Sans SC", system-ui, sans-serif; font-size: 14px; font-style: normal; font-weight: 500; letter-spacing: 0px; line-height: 22px; text-align: left; white-space: nowrap'
              >
                {{ identity.consistency }}
              </div>
            </div>
          </div>
          <div
            style="align-items: flex-start; box-sizing: border-box; display: flex; flex-direction: row; flex-shrink: 0; gap: 12px; height: fit-content; justify-content: space-between; width: 100%"
          >
            <div
              style='box-sizing: border-box; color: #53687A; flex-shrink: 0; font-family: "Noto Sans SC", system-ui, sans-serif; font-size: 14px; font-style: normal; font-weight: 400; letter-spacing: 0px; line-height: 22px; text-align: left; width: 84px'
            >
              出生日期
            </div>
            <div
              style='box-sizing: border-box; color: #23394C; flex: 1 1 0; font-family: "Noto Sans SC", system-ui, sans-serif; font-size: 16px; font-style: normal; font-weight: 400; letter-spacing: 0px; line-height: 26px; text-align: left'
            >
              {{ identity.birthday }}
            </div>
          </div>
          <div
            style="align-items: flex-start; box-sizing: border-box; display: flex; flex-direction: row; flex-shrink: 0; gap: 12px; height: fit-content; justify-content: space-between; width: 100%"
          >
            <div
              style='box-sizing: border-box; color: #53687A; flex-shrink: 0; font-family: "Noto Sans SC", system-ui, sans-serif; font-size: 14px; font-style: normal; font-weight: 400; letter-spacing: 0px; line-height: 22px; text-align: left; width: 84px'
            >
              国家／地区
            </div>
            <div
              style='box-sizing: border-box; color: #23394C; flex: 1 1 0; font-family: "Noto Sans SC", system-ui, sans-serif; font-size: 16px; font-style: normal; font-weight: 400; letter-spacing: 0px; line-height: 26px; text-align: left'
            >
              {{ identity.country }}
            </div>
          </div>
          <div
            style="align-items: flex-start; box-sizing: border-box; display: flex; flex-direction: row; flex-shrink: 0; gap: 12px; height: fit-content; justify-content: space-between; width: 100%"
          >
            <div
              style='box-sizing: border-box; color: #53687A; flex-shrink: 0; font-family: "Noto Sans SC", system-ui, sans-serif; font-size: 14px; font-style: normal; font-weight: 400; letter-spacing: 0px; line-height: 22px; text-align: left; width: 84px'
            >
              核验时间
            </div>
            <div
              style='box-sizing: border-box; color: #23394C; flex: 1 1 0; font-family: "Noto Sans SC", system-ui, sans-serif; font-size: 16px; font-style: normal; font-weight: 400; letter-spacing: 0px; line-height: 26px; text-align: left'
            >
              {{ verifyTimeStr }}
            </div>
          </div>
        </div>
        <!-- 项目经历 -->
        <div
          ref="anchorExperience"
          style="align-items: flex-start; background-color: #FBFAF6; border-radius: 7px; box-sizing: border-box; display: flex; flex-direction: column; flex-shrink: 0; gap: 10px; height: fit-content; justify-content: flex-start; outline-offset: -0.5px; outline: 1px solid #D6E0E6; padding: 14px; width: 100%"
        >
          <div
            style="align-items: center; box-sizing: border-box; display: flex; flex-direction: row; flex-shrink: 0; gap: 12px; height: fit-content; justify-content: space-between; width: 100%"
          >
            <div
              style='box-sizing: border-box; color: #152D43; font-family: "Noto Sans SC", system-ui, sans-serif; font-size: 18px; font-style: normal; font-weight: 600; letter-spacing: 0px; line-height: 25px; text-align: left; white-space: nowrap'
            >
              项目经历
            </div>
            <div
              style='box-sizing: border-box; color: #53687A; font-family: "Noto Sans SC", system-ui, sans-serif; font-size: 14px; font-style: normal; font-weight: 400; letter-spacing: 0px; line-height: 22px; text-align: left; white-space: nowrap'
            >
              {{ experience.records.length }} 个项目
            </div>
          </div>
          <div
            v-for="(rec, idx) in experience.records"
            :key="idx"
            style="align-items: flex-start; background-color: #FFFFFF; border-radius: 6px; box-sizing: border-box; display: flex; flex-direction: column; flex-shrink: 0; gap: 10px; height: fit-content; justify-content: flex-start; outline-offset: -0.5px; outline: 1px solid #E2E8EC; padding: 11px; width: 100%"
          >
            <div
              style='box-sizing: border-box; color: #223548; font-family: "Noto Sans SC", system-ui, sans-serif; font-size: 16px; font-style: normal; font-weight: 600; letter-spacing: 0px; line-height: 26px; text-align: left; width: 100%'
            >
              {{ rec.projectName }}
            </div>
            <div
              style='box-sizing: border-box; color: #546B7E; font-family: "Noto Sans SC", system-ui, sans-serif; font-size: 16px; font-style: normal; font-weight: 400; letter-spacing: 0px; line-height: 26px; text-align: left; width: 100%'
            >
              {{ rec.teamWorkType }}
            </div>
            <div
              style='box-sizing: border-box; color: #53687A; font-family: "Noto Sans SC", system-ui, sans-serif; font-size: 16px; font-style: normal; font-weight: 400; letter-spacing: 0px; line-height: 26px; text-align: left; width: 100%'
            >
              {{ rec.entryTime }}{{ rec.exitTime ? ' 至 ' + rec.exitTime : ' 至今' }}
            </div>
            <div
              style="align-items: flex-start; box-sizing: border-box; display: flex; flex-direction: column; flex-shrink: 0; gap: 12px; height: fit-content; justify-content: flex-start; width: 100%"
            >
              <div
                style="align-items: flex-start; box-sizing: border-box; display: flex; flex-direction: row; flex-shrink: 0; gap: 12px; height: fit-content; justify-content: space-between; width: 100%"
              >
                <div
                  style='box-sizing: border-box; color: #53687A; flex-shrink: 0; font-family: "Noto Sans SC", system-ui, sans-serif; font-size: 14px; font-style: normal; font-weight: 400; letter-spacing: 0px; line-height: 22px; text-align: left; width: 84px'
                >
                  项目编号
                </div>
                <div
                  style='box-sizing: border-box; color: #23394C; flex: 1 1 0; font-family: "Noto Sans SC", system-ui, sans-serif; font-size: 16px; font-style: normal; font-weight: 400; letter-spacing: 0px; line-height: 26px; text-align: left'
                >
                  {{ rec.projectNo }}
                </div>
              </div>
              <div
                style="align-items: flex-start; box-sizing: border-box; display: flex; flex-direction: row; flex-shrink: 0; gap: 12px; height: fit-content; justify-content: space-between; width: 100%"
              >
                <div
                  style='box-sizing: border-box; color: #53687A; flex-shrink: 0; font-family: "Noto Sans SC", system-ui, sans-serif; font-size: 14px; font-style: normal; font-weight: 400; letter-spacing: 0px; line-height: 22px; text-align: left; width: 84px'
                >
                  总包单位
                </div>
                <div
                  style='box-sizing: border-box; color: #23394C; flex: 1 1 0; font-family: "Noto Sans SC", system-ui, sans-serif; font-size: 16px; font-style: normal; font-weight: 400; letter-spacing: 0px; line-height: 26px; text-align: left'
                >
                  {{ rec.contractorName }}
                </div>
              </div>
              <div
                v-if="rec.subContractorName"
                style="align-items: flex-start; box-sizing: border-box; display: flex; flex-direction: row; flex-shrink: 0; gap: 12px; height: fit-content; justify-content: space-between; width: 100%"
              >
                <div
                  style='box-sizing: border-box; color: #53687A; flex-shrink: 0; font-family: "Noto Sans SC", system-ui, sans-serif; font-size: 14px; font-style: normal; font-weight: 400; letter-spacing: 0px; line-height: 22px; text-align: left; width: 84px'
                >
                  分包单位
                </div>
                <div
                  style='box-sizing: border-box; color: #23394C; flex: 1 1 0; font-family: "Noto Sans SC", system-ui, sans-serif; font-size: 16px; font-style: normal; font-weight: 400; letter-spacing: 0px; line-height: 26px; text-align: left'
                >
                  {{ rec.subContractorName }}
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- 风险相关核验详情（仅在有任一风险记录时渲染） -->
        <div
          v-if="hasRiskRecords"
          style="align-items: flex-start; box-sizing: border-box; display: flex; flex-direction: column; flex-shrink: 0; gap: 12px; height: fit-content; justify-content: flex-start; width: 100%"
        >
          <div
            style='box-sizing: border-box; color: #152D43; font-family: "Noto Sans SC", system-ui, sans-serif; font-size: 16px; font-style: normal; font-weight: 600; letter-spacing: 0px; line-height: 22px; text-align: left; width: 100%'
          >
            风险相关核验详情
          </div>
          <!-- 履约纠纷 -->
          <div
            v-if="dispute.records.length > 0"
            ref="anchorDispute"
            style="align-items: flex-start; background-color: #FBFAF6; border-radius: 7px; box-sizing: border-box; display: flex; flex-direction: column; flex-shrink: 0; gap: 10px; height: fit-content; justify-content: flex-start; outline-offset: -0.5px; outline: 1px solid #D6E0E6; padding: 14px; width: 100%"
          >
            <div
              style="align-items: center; box-sizing: border-box; display: flex; flex-direction: row; flex-shrink: 0; gap: 12px; height: fit-content; justify-content: space-between; width: 100%"
            >
              <div
                style="align-items: center; box-sizing: border-box; display: flex; flex-direction: row; flex-shrink: 0; gap: 8px; height: fit-content; justify-content: flex-start; width: fit-content"
              >
                <div
                  style='box-sizing: border-box; color: #152D43; font-family: "Noto Sans SC", system-ui, sans-serif; font-size: 18px; font-style: normal; font-weight: 600; letter-spacing: 0px; line-height: 25px; text-align: left; white-space: nowrap'
                >
                  履约纠纷
                </div>
                <div
                  style='box-sizing: border-box; color: #53687A; font-family: "Noto Sans SC", system-ui, sans-serif; font-size: 14px; font-style: normal; font-weight: 400; letter-spacing: 0px; line-height: 22px; text-align: left; white-space: nowrap'
                >
                  {{ dispute.records.length }} 条记录
                </div>
              </div>
              <div
                style="align-items: flex-start; border-radius: 6px; box-sizing: border-box; display: flex; flex-direction: row; flex-shrink: 0; gap: 0px; height: fit-content; justify-content: flex-start; padding: 4px 8px; width: fit-content"
                :style="riskLevel2styles[dispute.riskLevel]"
              >
                <div
                  style='box-sizing: border-box; font-family: "Noto Sans SC", system-ui, sans-serif; font-size: 14px; font-style: normal; font-weight: 500; letter-spacing: 0px; line-height: 22px; text-align: left; white-space: nowrap'
                >
                  {{ dispute.riskLevelDescription }}
                </div>
              </div>
            </div>
            <div
              v-for="(rec, idx) in dispute.records"
              :key="idx"
              style="align-items: flex-start; background-color: #FFFFFF; border-radius: 6px; box-sizing: border-box; display: flex; flex-direction: column; flex-shrink: 0; gap: 10px; height: fit-content; justify-content: flex-start; outline-offset: -0.5px; outline: 1px solid #E2E8EC; padding: 11px; width: 100%"
            >
              <div
                style='box-sizing: border-box; color: #223548; font-family: "Noto Sans SC", system-ui, sans-serif; font-size: 16px; font-style: normal; font-weight: 600; letter-spacing: 0px; line-height: 26px; text-align: left; width: 100%'
              >
                {{ rec.type }}
              </div>
              <div
                style="align-items: flex-start; box-sizing: border-box; display: flex; flex-direction: column; flex-shrink: 0; gap: 12px; height: fit-content; justify-content: flex-start; width: 100%"
              >
                <div
                  style="align-items: flex-start; box-sizing: border-box; display: flex; flex-direction: row; flex-shrink: 0; gap: 12px; height: fit-content; justify-content: space-between; width: 100%"
                >
                  <div
                    style='box-sizing: border-box; color: #53687A; flex-shrink: 0; font-family: "Noto Sans SC", system-ui, sans-serif; font-size: 14px; font-style: normal; font-weight: 400; letter-spacing: 0px; line-height: 22px; text-align: left; width: 84px'
                  >
                    投诉时间
                  </div>
                  <div
                    style='box-sizing: border-box; color: #23394C; flex: 1 1 0; font-family: "Noto Sans SC", system-ui, sans-serif; font-size: 16px; font-style: normal; font-weight: 400; letter-spacing: 0px; line-height: 26px; text-align: left'
                  >
                    {{ rec.complaintTime }}
                  </div>
                </div>
                <div
                  style="align-items: flex-start; box-sizing: border-box; display: flex; flex-direction: row; flex-shrink: 0; gap: 12px; height: fit-content; justify-content: space-between; width: 100%"
                >
                  <div
                    style='box-sizing: border-box; color: #53687A; flex-shrink: 0; font-family: "Noto Sans SC", system-ui, sans-serif; font-size: 14px; font-style: normal; font-weight: 400; letter-spacing: 0px; line-height: 22px; text-align: left; width: 84px'
                  >
                    关联项目
                  </div>
                  <div
                    style='box-sizing: border-box; color: #23394C; flex: 1 1 0; font-family: "Noto Sans SC", system-ui, sans-serif; font-size: 16px; font-style: normal; font-weight: 400; letter-spacing: 0px; line-height: 26px; text-align: left'
                  >
                    {{ rec.projectName }}
                  </div>
                </div>
                <div
                  v-if="rec.teamName"
                  style="align-items: flex-start; box-sizing: border-box; display: flex; flex-direction: row; flex-shrink: 0; gap: 12px; height: fit-content; justify-content: space-between; width: 100%"
                >
                  <div
                    style='box-sizing: border-box; color: #53687A; flex-shrink: 0; font-family: "Noto Sans SC", system-ui, sans-serif; font-size: 14px; font-style: normal; font-weight: 400; letter-spacing: 0px; line-height: 22px; text-align: left; width: 84px'
                  >
                    班组
                  </div>
                  <div
                    style='box-sizing: border-box; color: #23394C; flex: 1 1 0; font-family: "Noto Sans SC", system-ui, sans-serif; font-size: 16px; font-style: normal; font-weight: 400; letter-spacing: 0px; line-height: 26px; text-align: left'
                  >
                    {{ rec.teamName }}
                  </div>
                </div>
                <div
                  v-if="rec.handleStatus"
                  style="align-items: flex-start; box-sizing: border-box; display: flex; flex-direction: row; flex-shrink: 0; gap: 12px; height: fit-content; justify-content: space-between; width: 100%"
                >
                  <div
                    style='box-sizing: border-box; color: #53687A; flex-shrink: 0; font-family: "Noto Sans SC", system-ui, sans-serif; font-size: 14px; font-style: normal; font-weight: 400; letter-spacing: 0px; line-height: 22px; text-align: left; width: 84px'
                  >
                    处理状态
                  </div>
                  <div
                    style='box-sizing: border-box; color: #23394C; flex: 1 1 0; font-family: "Noto Sans SC", system-ui, sans-serif; font-size: 16px; font-style: normal; font-weight: 400; letter-spacing: 0px; line-height: 26px; text-align: left'
                  >
                    {{ rec.handleStatus }}
                  </div>
                </div>
                <div
                  v-if="rec.note"
                  style="align-items: flex-start; box-sizing: border-box; display: flex; flex-direction: row; flex-shrink: 0; gap: 12px; height: fit-content; justify-content: space-between; width: 100%"
                >
                  <div
                    style='box-sizing: border-box; color: #53687A; flex-shrink: 0; font-family: "Noto Sans SC", system-ui, sans-serif; font-size: 14px; font-style: normal; font-weight: 400; letter-spacing: 0px; line-height: 22px; text-align: left; width: 84px'
                  >
                    处理意见
                  </div>
                  <div
                    style='box-sizing: border-box; color: #23394C; flex: 1 1 0; font-family: "Noto Sans SC", system-ui, sans-serif; font-size: 16px; font-style: normal; font-weight: 400; letter-spacing: 0px; line-height: 26px; text-align: left'
                  >
                    {{ rec.note }}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- 不良记录 -->
          <div
            v-if="adverse.records.length > 0"
            ref="anchorAdverse"
            style="align-items: flex-start; background-color: #FBFAF6; border-radius: 7px; box-sizing: border-box; display: flex; flex-direction: column; flex-shrink: 0; gap: 10px; height: fit-content; justify-content: flex-start; outline-offset: -0.5px; outline: 1px solid #D6E0E6; padding: 14px; width: 100%"
          >
            <div
              style="align-items: center; box-sizing: border-box; display: flex; flex-direction: row; flex-shrink: 0; gap: 12px; height: fit-content; justify-content: space-between; width: 100%"
            >
              <div
                style="align-items: center; box-sizing: border-box; display: flex; flex-direction: row; flex-shrink: 0; gap: 8px; height: fit-content; justify-content: flex-start; width: fit-content"
              >
                <div
                  style='box-sizing: border-box; color: #152D43; font-family: "Noto Sans SC", system-ui, sans-serif; font-size: 18px; font-style: normal; font-weight: 600; letter-spacing: 0px; line-height: 25px; text-align: left; white-space: nowrap'
                >
                  不良记录
                </div>
                <div
                  style='box-sizing: border-box; color: #53687A; font-family: "Noto Sans SC", system-ui, sans-serif; font-size: 14px; font-style: normal; font-weight: 400; letter-spacing: 0px; line-height: 22px; text-align: left; white-space: nowrap'
                >
                  {{ adverse.records.length }} 条记录
                </div>
              </div>
              <div
                style="align-items: flex-start; border-radius: 6px; box-sizing: border-box; display: flex; flex-direction: row; flex-shrink: 0; gap: 0px; height: fit-content; justify-content: flex-start; padding: 4px 8px; width: fit-content"
                :style="riskLevel2styles[adverse.riskLevel]"
              >
                <div
                  style='box-sizing: border-box; font-family: "Noto Sans SC", system-ui, sans-serif; font-size: 14px; font-style: normal; font-weight: 500; letter-spacing: 0px; line-height: 22px; text-align: left; white-space: nowrap'
                >
                  {{ adverse.riskLevelDescription }}
                </div>
              </div>
            </div>
            <div
              v-for="(rec, idx) in adverse.records"
              :key="idx"
              style="align-items: flex-start; background-color: #FFFFFF; border-radius: 6px; box-sizing: border-box; display: flex; flex-direction: column; flex-shrink: 0; gap: 10px; height: fit-content; justify-content: flex-start; outline-offset: -0.5px; outline: 1px solid #E2E8EC; padding: 11px; width: 100%"
            >
              <div
                style="align-items: flex-start; box-sizing: border-box; display: flex; flex-direction: column; flex-shrink: 0; gap: 12px; height: fit-content; justify-content: flex-start; width: 100%"
              >
                <div
                  style="align-items: flex-start; box-sizing: border-box; display: flex; flex-direction: row; flex-shrink: 0; gap: 12px; height: fit-content; justify-content: space-between; width: 100%"
                >
                  <div
                    style='box-sizing: border-box; color: #53687A; flex-shrink: 0; font-family: "Noto Sans SC", system-ui, sans-serif; font-size: 14px; font-style: normal; font-weight: 400; letter-spacing: 0px; line-height: 22px; text-align: left; width: 84px'
                  >
                    记录编号
                  </div>
                  <div
                    style='box-sizing: border-box; color: #23394C; flex: 1 1 0; font-family: "Noto Sans SC", system-ui, sans-serif; font-size: 16px; font-style: normal; font-weight: 400; letter-spacing: 0px; line-height: 26px; text-align: left'
                  >
                    {{ rec.sysNo }}
                  </div>
                </div>
                <div
                  style="align-items: flex-start; box-sizing: border-box; display: flex; flex-direction: row; flex-shrink: 0; gap: 12px; height: fit-content; justify-content: space-between; width: 100%"
                >
                  <div
                    style='box-sizing: border-box; color: #53687A; flex-shrink: 0; font-family: "Noto Sans SC", system-ui, sans-serif; font-size: 14px; font-style: normal; font-weight: 400; letter-spacing: 0px; line-height: 22px; text-align: left; width: 84px'
                  >
                    人员
                  </div>
                  <div
                    style='box-sizing: border-box; color: #23394C; flex: 1 1 0; font-family: "Noto Sans SC", system-ui, sans-serif; font-size: 16px; font-style: normal; font-weight: 400; letter-spacing: 0px; line-height: 26px; text-align: left'
                  >
                    {{ rec.name }}
                  </div>
                </div>
                <div
                  style="align-items: flex-start; box-sizing: border-box; display: flex; flex-direction: row; flex-shrink: 0; gap: 12px; height: fit-content; justify-content: space-between; width: 100%"
                >
                  <div
                    style='box-sizing: border-box; color: #53687A; flex-shrink: 0; font-family: "Noto Sans SC", system-ui, sans-serif; font-size: 14px; font-style: normal; font-weight: 400; letter-spacing: 0px; line-height: 22px; text-align: left; width: 84px'
                  >
                    关联项目
                  </div>
                  <div
                    style='box-sizing: border-box; color: #23394C; flex: 1 1 0; font-family: "Noto Sans SC", system-ui, sans-serif; font-size: 16px; font-style: normal; font-weight: 400; letter-spacing: 0px; line-height: 26px; text-align: left'
                  >
                    {{ rec.projectName }}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- 证书核验（职业证书 + 特种证书合并） -->
          <div
            v-if="vocational.records.length > 0 || special.records.length > 0"
            ref="anchorCertificate"
            style="align-items: flex-start; background-color: #FBFAF6; border-radius: 7px; box-sizing: border-box; display: flex; flex-direction: column; flex-shrink: 0; gap: 10px; height: fit-content; justify-content: flex-start; outline-offset: -0.5px; outline: 1px solid #D6E0E6; padding: 14px; width: 100%"
          >
            <div
              style="align-items: center; box-sizing: border-box; display: flex; flex-direction: row; flex-shrink: 0; gap: 12px; height: fit-content; justify-content: space-between; width: 100%"
            >
              <div
                style='box-sizing: border-box; color: #152D43; font-family: "Noto Sans SC", system-ui, sans-serif; font-size: 18px; font-style: normal; font-weight: 600; letter-spacing: 0px; line-height: 25px; text-align: left; white-space: nowrap'
              >
                证书核验
              </div>
            </div>
            <div
              style="align-items: flex-start; box-sizing: border-box; display: flex; flex-direction: column; flex-shrink: 0; gap: 8px; height: fit-content; justify-content: flex-start; width: 100%"
            >
              <div
                style='box-sizing: border-box; color: #223548; font-family: "Noto Sans SC", system-ui, sans-serif; font-size: 16px; font-style: normal; font-weight: 500; letter-spacing: 0px; line-height: 26px; text-align: left; width: 100%'
              >
                职业证书
              </div>
              <div
                v-if="vocational.records.length === 0"
                style='box-sizing: border-box; color: #53687A; font-family: "Noto Sans SC", system-ui, sans-serif; font-size: 16px; font-style: normal; font-weight: 400; letter-spacing: 0px; line-height: 26px; text-align: left; width: 100%'
              >
                未查询到证书记录
              </div>
              <div
                v-for="(rec, idx) in vocational.records"
                :key="idx"
                style="align-items: flex-start; background-color: #FFFFFF; border-radius: 6px; box-sizing: border-box; display: flex; flex-direction: column; flex-shrink: 0; gap: 10px; height: fit-content; justify-content: flex-start; outline-offset: -0.5px; outline: 1px solid #E2E8EC; padding: 11px; width: 100%"
              >
                <div
                  style='box-sizing: border-box; color: #223548; font-family: "Noto Sans SC", system-ui, sans-serif; font-size: 16px; font-style: normal; font-weight: 600; letter-spacing: 0px; line-height: 26px; text-align: left; width: 100%'
                >
                  {{ rec.name }}
                </div>
                <div
                  style="align-items: flex-start; box-sizing: border-box; display: flex; flex-direction: column; flex-shrink: 0; gap: 12px; height: fit-content; justify-content: flex-start; width: 100%"
                >
                  <div
                    style="align-items: flex-start; box-sizing: border-box; display: flex; flex-direction: row; flex-shrink: 0; gap: 12px; height: fit-content; justify-content: space-between; width: 100%"
                  >
                    <div
                      style='box-sizing: border-box; color: #53687A; flex-shrink: 0; font-family: "Noto Sans SC", system-ui, sans-serif; font-size: 14px; font-style: normal; font-weight: 400; letter-spacing: 0px; line-height: 22px; text-align: left; width: 84px'
                    >
                      证书编号
                    </div>
                    <div
                      style='box-sizing: border-box; color: #23394C; flex: 1 1 0; font-family: "Noto Sans SC", system-ui, sans-serif; font-size: 16px; font-style: normal; font-weight: 400; letter-spacing: 0px; line-height: 26px; text-align: left'
                    >
                      {{ rec.no }}
                    </div>
                  </div>
                  <div
                    v-if="rec.levelName"
                    style="align-items: flex-start; box-sizing: border-box; display: flex; flex-direction: row; flex-shrink: 0; gap: 12px; height: fit-content; justify-content: space-between; width: 100%"
                  >
                    <div
                      style='box-sizing: border-box; color: #53687A; flex-shrink: 0; font-family: "Noto Sans SC", system-ui, sans-serif; font-size: 14px; font-style: normal; font-weight: 400; letter-spacing: 0px; line-height: 22px; text-align: left; width: 84px'
                    >
                      证书等级
                    </div>
                    <div
                      style='box-sizing: border-box; color: #23394C; flex: 1 1 0; font-family: "Noto Sans SC", system-ui, sans-serif; font-size: 16px; font-style: normal; font-weight: 400; letter-spacing: 0px; line-height: 26px; text-align: left'
                    >
                      {{ rec.levelName }}
                    </div>
                  </div>
                  <div
                    style="align-items: flex-start; box-sizing: border-box; display: flex; flex-direction: row; flex-shrink: 0; gap: 12px; height: fit-content; justify-content: space-between; width: 100%"
                  >
                    <div
                      style='box-sizing: border-box; color: #53687A; flex-shrink: 0; font-family: "Noto Sans SC", system-ui, sans-serif; font-size: 14px; font-style: normal; font-weight: 400; letter-spacing: 0px; line-height: 22px; text-align: left; width: 84px'
                    >
                      有效期限
                    </div>
                    <div
                      style='box-sizing: border-box; color: #23394C; flex: 1 1 0; font-family: "Noto Sans SC", system-ui, sans-serif; font-size: 16px; font-style: normal; font-weight: 400; letter-spacing: 0px; line-height: 26px; text-align: left'
                    >
                      {{ rec.validBeginDate }} 至 {{ rec.validEndDate }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div
              style="align-items: flex-start; box-sizing: border-box; display: flex; flex-direction: column; flex-shrink: 0; gap: 8px; height: fit-content; justify-content: flex-start; width: 100%"
            >
              <div
                style='box-sizing: border-box; color: #223548; font-family: "Noto Sans SC", system-ui, sans-serif; font-size: 16px; font-style: normal; font-weight: 500; letter-spacing: 0px; line-height: 26px; text-align: left; width: 100%'
              >
                特种证书
              </div>
              <div
                v-if="special.records.length === 0"
                style='box-sizing: border-box; color: #53687A; font-family: "Noto Sans SC", system-ui, sans-serif; font-size: 16px; font-style: normal; font-weight: 400; letter-spacing: 0px; line-height: 26px; text-align: left; width: 100%'
              >
                未查询到证书记录
              </div>
              <div
                v-for="(rec, idx) in special.records"
                :key="idx"
                style="align-items: flex-start; background-color: #FFFFFF; border-radius: 6px; box-sizing: border-box; display: flex; flex-direction: column; flex-shrink: 0; gap: 10px; height: fit-content; justify-content: flex-start; outline-offset: -0.5px; outline: 1px solid #E2E8EC; padding: 11px; width: 100%"
              >
                <div
                  style='box-sizing: border-box; color: #223548; font-family: "Noto Sans SC", system-ui, sans-serif; font-size: 16px; font-style: normal; font-weight: 600; letter-spacing: 0px; line-height: 26px; text-align: left; width: 100%'
                >
                  {{ rec.name }}
                </div>
                <div
                  style="align-items: flex-start; box-sizing: border-box; display: flex; flex-direction: column; flex-shrink: 0; gap: 12px; height: fit-content; justify-content: flex-start; width: 100%"
                >
                  <div
                    style="align-items: flex-start; box-sizing: border-box; display: flex; flex-direction: row; flex-shrink: 0; gap: 12px; height: fit-content; justify-content: space-between; width: 100%"
                  >
                    <div
                      style='box-sizing: border-box; color: #53687A; flex-shrink: 0; font-family: "Noto Sans SC", system-ui, sans-serif; font-size: 14px; font-style: normal; font-weight: 400; letter-spacing: 0px; line-height: 22px; text-align: left; width: 84px'
                    >
                      证书编号
                    </div>
                    <div
                      style='box-sizing: border-box; color: #23394C; flex: 1 1 0; font-family: "Noto Sans SC", system-ui, sans-serif; font-size: 16px; font-style: normal; font-weight: 400; letter-spacing: 0px; line-height: 26px; text-align: left'
                    >
                      {{ rec.no }}
                    </div>
                  </div>
                  <div
                    v-if="rec.levelName"
                    style="align-items: flex-start; box-sizing: border-box; display: flex; flex-direction: row; flex-shrink: 0; gap: 12px; height: fit-content; justify-content: space-between; width: 100%"
                  >
                    <div
                      style='box-sizing: border-box; color: #53687A; flex-shrink: 0; font-family: "Noto Sans SC", system-ui, sans-serif; font-size: 14px; font-style: normal; font-weight: 400; letter-spacing: 0px; line-height: 22px; text-align: left; width: 84px'
                    >
                      证书等级
                    </div>
                    <div
                      style='box-sizing: border-box; color: #23394C; flex: 1 1 0; font-family: "Noto Sans SC", system-ui, sans-serif; font-size: 16px; font-style: normal; font-weight: 400; letter-spacing: 0px; line-height: 26px; text-align: left'
                    >
                      {{ rec.levelName }}
                    </div>
                  </div>
                  <div
                    style="align-items: flex-start; box-sizing: border-box; display: flex; flex-direction: row; flex-shrink: 0; gap: 12px; height: fit-content; justify-content: space-between; width: 100%"
                  >
                    <div
                      style='box-sizing: border-box; color: #53687A; flex-shrink: 0; font-family: "Noto Sans SC", system-ui, sans-serif; font-size: 14px; font-style: normal; font-weight: 400; letter-spacing: 0px; line-height: 22px; text-align: left; width: 84px'
                    >
                      有效期限
                    </div>
                    <div
                      style='box-sizing: border-box; color: #23394C; flex: 1 1 0; font-family: "Noto Sans SC", system-ui, sans-serif; font-size: 16px; font-style: normal; font-weight: 400; letter-spacing: 0px; line-height: 26px; text-align: left'
                    >
                      {{ rec.validBeginDate }} 至 {{ rec.validEndDate }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- 报告信息区 -->
      <div
        style="align-items: flex-start; background-color: #EEF2F3; box-sizing: border-box; display: flex; flex-direction: column; flex-shrink: 0; gap: 12px; height: fit-content; justify-content: flex-start; padding: 0px 12px 16px 12px; width: 100%"
      >
        <div
          style="align-items: flex-start; background-color: #FBFAF6; border-radius: 7px; box-sizing: border-box; display: flex; flex-direction: column; flex-shrink: 0; gap: 8px; height: fit-content; justify-content: flex-start; outline-offset: -0.5px; outline: 1px solid #D6E0E6; padding: 13px; width: 100%"
        >
          <div
            style='box-sizing: border-box; color: #546B7E; font-family: "Noto Sans SC", system-ui, sans-serif; font-size: 16px; font-style: normal; font-weight: 600; letter-spacing: 0px; line-height: 26px; text-align: left; width: 100%'
          >
            报告信息
          </div>
          <div
            style='box-sizing: border-box; color: #53687A; font-family: "Noto Sans SC", system-ui, sans-serif; font-size: 14px; font-style: normal; font-weight: 400; letter-spacing: 0px; line-height: 22px; text-align: left; width: 100%'
          >
            报告生成时间 {{ generatedTimeStr }}
          </div>
        </div>
        <div
          style="align-items: flex-start; background-color: #FFFFFF; border-radius: 8px; box-sizing: border-box; display: flex; flex-direction: column; flex-shrink: 0; gap: 16px; height: fit-content; justify-content: flex-start; outline-offset: -0.5px; outline: 1px solid #D6E0E6; padding: 16px; width: 100%"
        >
          <div
            style='box-sizing: border-box; color: #24384B; font-family: "Noto Sans SC", system-ui, sans-serif; font-size: 18px; font-style: normal; font-weight: 700; letter-spacing: 0px; line-height: normal; text-align: left; white-space: nowrap'
          >
            报告数据来源
          </div>
          <template v-for="(ds, idx) in dataSources">
            <div
              v-if="idx > 0"
              :key="'sep' + idx"
              style="background-color: #E8EDF1; box-sizing: border-box; flex-shrink: 0; height: 1px; width: 100%"
            ></div>
            <div
              :key="`src${idx}`"
              style="align-items: flex-start; box-sizing: border-box; display: flex; flex-direction: column; flex-shrink: 0; gap: 4px; height: fit-content; justify-content: flex-start; width: 100%"
            >
              <div
                style='box-sizing: border-box; color: #24384B; font-family: "Noto Sans SC", system-ui, sans-serif; font-size: 16px; font-style: normal; font-weight: 500; letter-spacing: 0px; line-height: 24px; text-align: left; width: 100%'
              >
                {{ ds.sourceName }}
              </div>
              <div
                style='box-sizing: border-box; color: #647786; font-family: "Noto Sans SC", system-ui, sans-serif; font-size: 14px; font-style: normal; font-weight: 400; letter-spacing: 0px; line-height: 21px; text-align: left; width: 100%'
              >
                {{ ds.items }}
              </div>
            </div>
          </template>
        </div>
        <div
          style='box-sizing: border-box; color: #647786; font-family: "Noto Sans SC", system-ui, sans-serif; font-size: 14px; font-style: normal; font-weight: 400; letter-spacing: 0px; line-height: 22px; text-align: left; width: 100%'
        >
          报告内容仅供本次授权核查及用工审核参考。
        </div>
      </div>
      <!-- 底部操作区 -->
      <div
        style="align-items: flex-start; background-color: #EEF2F3; box-sizing: border-box; display: flex; flex-direction: column; flex-shrink: 0; gap: 12px; height: fit-content; justify-content: flex-start; padding: 0px 12px 16px 12px; width: 100%"
      >
        <div
          style="align-items: center; background-color: #0B263F; border-radius: 7px; box-sizing: border-box; display: flex; flex-direction: row; flex-shrink: 0; gap: 8px; height: 50px; justify-content: center; width: 100%"
          @click="downloadReport"
        >
          <svg
            data-icon-name="download"
            data-icon-set="lucide"
            viewBox="0 0 13.99993896484375 14"
            preserveAspectRatio="xMidYMid meet"
            xmlns="http://www.w3.org/2000/svg"
            style="box-sizing: border-box; flex-shrink: 0; height: 18px; width: 18px"
          >
            <path
              d="M6.84619 1.18945q-0.25293 0.08545-0.37939 0.30762l-0.04102 0.08545 0 5.75244-0.99463-0.99463q-0.62891-0.62891-0.83398-0.81689-0.20166-0.18799-0.25635-0.21875-0.19824-0.08203-0.3999-0.02393-0.20166 0.05469-0.32813 0.21533-0.12646 0.16064-0.11279 0.36914l0 0.02735q0.01367 0.11279 0.06836 0.19824 0.07178 0.11279 0.36572 0.42041l1.20313 1.20313q1.52783 1.52441 1.59619 1.56884 0.05811 0.02734 0.10596 0.03418 0.04785 0.00684 0.16064 0.00684 0.11279 0 0.16064-0.00684 0.04785-0.00684 0.10596-0.03418 0.06836-0.04443 1.59619-1.56884 1.03564-1.03564 1.28516-1.30225 0.25293-0.2666 0.29736-0.33496 0.0957-0.22559 0.01026-0.44776-0.08203-0.22559-0.32129-0.33837-0.08203-0.02734-0.22217-0.02735l-0.02734 0q-0.12646 0-0.19825 0.02735-0.0957 0.05811-0.30761 0.25293-0.15381 0.15381-0.69727 0.70068l-1.10742 1.09033 0-5.75244-0.04102-0.08545q-0.09912-0.18115-0.28027-0.2666-0.08545-0.04102-0.22559-0.04785-0.14014-0.00684-0.18115 0.00683z m-5.25 7q-0.25293 0.08545-0.37939 0.30762l-0.04102 0.08545 0.01367 2.60449q0 0.23584 0.02735 0.30762 0.14014 0.48877 0.46826 0.82031 0.33154 0.32813 0.82031 0.46826 0.08545 0.02734 0.71436 0.02735l3.78027 0.01367 3.78027-0.01367q0.62891 0 0.71436-0.02735 0.48877-0.14014 0.81689-0.46826 0.33154-0.33154 0.47168-0.82031 0.02734-0.07178 0.02735-0.30762l0.01367-2.60449-0.04102-0.08545q-0.09912-0.16748-0.28027-0.2666-0.05811-0.02734-0.09912-0.04102-0.04102-0.01367-0.15381-0.01367-0.11279 0-0.15381 0.01367-0.04101 0.01367-0.09912 0.04102-0.18115 0.09912-0.28027 0.2666l-0.04102 0.08545-0.01367 2.63183-0.04102 0.09913q-0.14014 0.27685-0.43408 0.33496-0.09912 0.02734-4.18701 0.02734-4.08789 0-4.18701-0.02734-0.29395-0.05811-0.43408-0.33496l-0.04102-0.09913-0.01367-2.63183-0.04102-0.08545q-0.09912-0.18115-0.28027-0.2666-0.08545-0.04102-0.22559-0.04785-0.14014-0.00684-0.18115 0.00683z"
              fill="#FFFFFF"
            ></path>
          </svg>
          <div
            style='box-sizing: border-box; color: #FFFFFF; font-family: "Noto Sans SC", system-ui, sans-serif; font-size: 16px; font-style: normal; font-weight: 600; letter-spacing: 0px; line-height: 26px; text-align: left; white-space: nowrap'
          >
            下载报告
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import req from '../../../req';

function emptyDim() {
  return {
    riskLevel: '', riskLevelDescription: '', records: [],
  };
}

const riskLevel2styles = {
  '00': { backgroundColor: '#E3F5ED', color: '#147052' },
  '01': { backgroundColor: '#E3F5ED', color: '#147052' },
  '02': { backgroundColor: '#FFF7E8', color: '#9A5B0A' },
  '03': { backgroundColor: '#FFF4F3', color: '#A22031' },
  '04': { backgroundColor: '#FFF4F3', color: '#A22031' },
};

// 风险等级色系映射（设计稿 report_1「未见风险」/ report_2「有风险」形态）
const RISK_THEME = {
  none: { // 未见风险 '00'/'01'
    icon: 'shield-check',
    backgroundColor: '#F0F6FC',
    outlineColor: '#CCDEEF',
    color: '#215C9D',
    iconFill: '#2F70BD',
    textColor: '#314E67',
    titleColor: '#39617E',
  },
  medium: { // 有风险/中风险 '02'
    icon: 'shield-alert',
    backgroundColor: '#FFF9F1',
    outlineColor: '#E8CBA9',
    color: '#9B560E',
    iconFill: '#B16B1A',
    textColor: '#654D35',
    titleColor: '#8E5F2A',
  },
  high: { // 高风险 '03'/'04'，设计稿未提供该形态，outline 取同色系加深
    icon: 'shield-alert',
    backgroundColor: '#FFF4F3',
    outlineColor: '#F0C4BF',
    color: '#A22031',
    iconFill: '#A22031',
    textColor: '#6B3A3D',
    titleColor: '#A22031',
  },
};

function riskTheme(level) {
  if (level === '02' || level === 'MEDIUM') return RISK_THEME.medium;
  if (level === '03' || level === '04' || level === 'HIGH') return RISK_THEME.high;
  return RISK_THEME.none;
}

function fix2(n) {
  return n > 9 ? n : `0${n}`;
}

function time2Str(time) {
  if (!time) return '-';
  const date = new Date(time);
  return `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()} ${fix2(date.getHours())}:${fix2(date.getMinutes())}`;
}

export default {
  name: 'WorkerCheckReportFull',
  data() {
    return {
      person: { name: '', idCard: '', headImg: '' },
      risk: {
        level: '',
        levelDescription: '',
        score: 0,
        riskValue: 0,
      },
      aiConclusion: '',
      aiSuggestion: '',
      keyRisks: [],
      generatedTime: '',
      identity: {
        birthday: '',
        country: '',
        consistency: '',
        verifyTime: '',
      },
      experience: emptyDim(),
      dispute: emptyDim(),
      adverse: emptyDim(),
      vocational: emptyDim(),
      special: emptyDim(),
      dataSources: [],
      riskLevel2styles,
    };
  },
  computed: {
    verifyTimeStr() {
      const { verifyTime } = this.identity;
      return time2Str(verifyTime);
    },
    generatedTimeStr() {
      return time2Str(this.generatedTime);
    },
    resultTheme() {
      return riskTheme(this.risk.level);
    },
    hasRiskRecords() {
      const {
        dispute, adverse, vocational, special,
      } = this;
      return dispute.records.length > 0
        || adverse.records.length > 0
        || vocational.records.length > 0
        || special.records.length > 0;
    },
  },
  mounted() {
    const { sessionId, reportId } = this.$route.query;
    if (sessionId) {
      req.session.set(sessionId);
    }
    if (!reportId) {
      req.err.show('缺少报告ID');
      return;
    }
    this.pid = null;
    // 并行请求：overview 提供人员/风险/AI 解读，detail 提供各维度明细
    this.fetchOverview();
    this.fetchDetail();
  },
  methods: {
    keyRiskTheme(level) {
      return riskTheme(level);
    },
    // 「重点关注」条目名称 → 明细模块锚点 ref 名
    keyRiskAnchorRef(itemName) {
      const name = itemName || '';
      if (name.indexOf('纠纷') >= 0 || name.indexOf('履约') >= 0) return 'anchorDispute';
      if (name.indexOf('不良') >= 0) return 'anchorAdverse';
      if (name.indexOf('职业证书') >= 0 || name.indexOf('特种证书') >= 0 || name.indexOf('证书') >= 0) return 'anchorCertificate';
      if (name.indexOf('项目') >= 0) return 'anchorExperience';
      if (name.indexOf('身份') >= 0) return 'anchorIdentity';
      return '';
    },
    scrollToRecord(kr) {
      const refName = this.keyRiskAnchorRef(kr && kr.item);
      if (!refName) return;
      const el = this.$refs[refName];
      const target = Array.isArray(el) ? el[0] : el;
      if (target && target.scrollIntoView) {
        target.scrollIntoView({ behavior: 'smooth' });
      }
    },
    /**
     * 获取我的权限列表
     */
    async getAuthority() {
      const { pid } = this;
      try {
        const res = await req.authority.getCrtAuthorityList({
          childProjectId: pid,
          projectId: pid,
        });
        if (res.code !== 0) {
          throw new Error(res.msg);
        }
        const codeMap = res.data.projectPermissions.reduce((prev, cur) => ({ ...prev, [cur.code]: cur }), {});
        const VIEW_AI_CHECK_DATA = '70001001'; // 查看AI背调数据
        const VIEW_AI_CHECK_REPORT = '70001004'; // 查看AI背调报告
        const MANAGE_AI_CHECK_INITIATE = '70001002'; // 发起背调
        const MANAGE_AI_CHECK_DOWNLOAD = '70001003'; // 下载报告
        return {
          viewAiCheckData: !!codeMap[VIEW_AI_CHECK_DATA],
          viewAiCheckReport: !!codeMap[VIEW_AI_CHECK_REPORT],
          manageAiCheckInitiate: !!codeMap[MANAGE_AI_CHECK_INITIATE],
          manageAiCheckDownload: !!codeMap[MANAGE_AI_CHECK_DOWNLOAD],
        };
      } catch (err) {
        req.err.show(err);
        return {};
      }
    },
    async downloadReport() {
      const { reportId } = this.$route.query;
      if (!reportId) {
        req.err.show('缺少报告ID');
        return;
      }
      const { manageAiCheckDownload } = await this.getAuthority();
      if (!manageAiCheckDownload) {
        req.err.show('您暂无权限，请联系超管授权');
        return;
      }
      const key = '__wxjs_environment';
      if (window[key] === 'miniprogram') {
        wx.miniProgram.navigateTo({ url: `/pages/ai_check/export/index?reportId=${reportId}` });
        return;
      }
      this.$router.push({
        name: 'ai_check.worker_check_report_full',
        query: { reportId },
      });
    },
    fetchOverview() {
      const { reportId } = this.$route.query;
      req.aiCheck
        .reportOverview(reportId)
        .then((res) => {
          if (res.code !== 0) {
            req.err.show(res);
            return;
          }
          const data = res.data || {};
          // data.risk.level = '02';
          // 人员信息、风险等级以 overview 为准
          this.person = { ...this.person, ...(data.person || {}) };
          this.risk = { ...this.risk, ...(data.risk || {}) };
          this.aiConclusion = data.aiConclusion || '';
          this.aiSuggestion = data.aiSuggestion || '';
          this.keyRisks = data.keyRisks || [];
        })
        .catch((err) => {
          req.err.show(err);
        });
    },
    fetchDetail() {
      const { reportId } = this.$route.query;
      req.aiCheck
        .reportDetail(reportId)
        .then((res) => {
          if (res.code !== 0) {
            req.err.show(res);
            return;
          }
          const data = res.data || {};
          const dim = (d) => ({ ...emptyDim(), ...(d || {}), records: (d && d.records) || [] });
          this.generatedTime = data.generatedTime || '';
          this.identity = { ...this.identity, ...(data.identity || {}) };
          this.experience = dim(data.experience);
          this.dispute = dim(data.dispute);
          this.adverse = dim(data.adverse);
          this.vocational = dim(data.vocational);
          this.special = dim(data.special);
          this.dataSources = data.dataSources || [];
          this.pid = data.projectId || '';
        })
        .catch((err) => {
          req.err.show(err);
        });
    },
  },
};
</script>
